import Swal from "sweetalert2";
import moment from "moment";
import Add from "./Add/Add.vue";

export default {
  name: "AddUser",
  created() {
    this.GetKidneyCenters();
    this.GetCities();
    this.Getmunicipalities();
    this.GetAllCompanies();
  },
  components: {
    Add: Add,
  },
  filters: {
    moment: function(date) {
      if (date === null) {
        return "فارغ";
      }
      // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
      return moment(date).format("MMMM Do YYYY");
    },
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      pages: 0,
      state: 0,
      KidneyCenters: [],
      citis: [],
      Devices: [],
      DevicesTable: [],

      companies: [],
      Municipalities: [],
      SelectedItem: "",
      companiesId: "",
      Kid:'',
      ruleForm2: {
        KidneyCentersId: "",
        DeviceId: "",
        Count: 0,
      },
      rules2: {
        KidneyCentersId: this.$helper.Required(),
        DeviceId: this.$helper.Required(),
        Count: this.$helper.Required(),
      },
      ruleForm: {
        Id: null,
        MunicipalityId: "",
        ArabicName: "",
        EnglishName: "",
      },
      rules: {
        MunicipalityId: this.$helper.Required(),
        ArabicName: this.$helper.ArabicOnly(),
        EnglishName: this.$helper.Required(),
      },
    };
  },
  methods: {
    GetDviceById() {
      this.$blockUI.Start();
      this.$http
        .GetDviceById(this.companiesId)
        .then((response) => {
          this.$blockUI.Stop();
          this.Devices = response.data.info;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    GetAllCompanies() {
      this.$blockUI.Start();
      this.$http
        .GetAllCompanies()
        .then((response) => {
          this.$blockUI.Stop();
          this.companies = response.data.info;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    edit(item) {
      this.ruleForm.Id = item.id;
      this.ruleForm.MunicipalityId = item.municipality.municipalityId;
      this.ruleForm.ArabicName = item.arabicName;
      this.ruleForm.EnglishName = item.englishName;
      document.getElementById("open").click();
    },

    submitForm(formName) {
      if (this.$helper.submitForm(this.$refs[formName])) {
        if (this.ruleForm.Id) {
          return this.update(formName);
        }
        this.Add(formName);
      }
    },

    submitForm2(formName) {
      if (this.$helper.submitForm(this.$refs[formName])) {
        this.AddDevice(formName);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    update(formName) {
      this.$blockUI.Start();
      this.$http
        .UpdateKidneyCenters(this.ruleForm)
        .then(() => {
          this.$blockUI.Stop();
          Swal.fire({
            icon: "success",
            title: "تم الحفظ بنجاح",
            showCancelButton: false,
          }).then(() => {});
          this.GetKidneyCenters();
          document.getElementById("close").click();
          this.resetForm(formName);
          this.ruleForm.Id = null;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    Add(formName) {
      this.$blockUI.Start();
      this.$http
        .AddKidneyCenters(this.ruleForm)
        .then(() => {
          this.$blockUI.Stop();
          Swal.fire({
            icon: "success",
            title: "تم الحفظ بنجاح",
            showCancelButton: false,
          }).then(() => {});
          this.GetKidneyCenters();
          document.getElementById("close").click();
          this.resetForm(formName);
          this.ruleForm.Id = null;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    AddItemPage() {
      this.state = 1;
    },
    show(item) {
      this.ruleForm2.KidneyCentersId = item.id;
      this.$blockUI.Start();
      this.$http
        .ShowDevices(item.id)
        .then(res => {
            this.Kid = item.id
          this.$blockUI.Stop();
          this.DevicesTable = res.data.info
          document.getElementById("openDevices").click();
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },

    deleteDevice(id){
        Swal.fire({
            title: "هـل انت متأكد من عملية الحذف ؟",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `تأكيد العملية`,
            denyButtonText: `الغاء العملية`,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$blockUI.Start();
              this.$http
                .deleteDeviceKidny(id)
                .then((response) => {
                  this.$blockUI.Stop();
                  this.FormPorgress = 100;
                  Swal.fire({
                    icon: "success",
                    title: "..نجـاح العملية",
                    html: response.data,
                    showCancelButton: false,
                    //confirmButtonText: `حـفظ`,
                  }).then(() => {
                    this.$blockUI.Stop();
                    this.show(this.Kid)
                  });
                })
                .catch((err) => {
                  this.$blockUI.Stop();
                  this.$helper.showWorning(err.response.data);
                });
              return;
            }
          });
    },
    GetCities() {
      this.$blockUI.Start();
      this.$http
        .GetCities(this.pageNo, this.pageSize)
        .then((response) => {
          this.$blockUI.Stop();
          this.citis = response.data.info;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },

    Getmunicipalities() {
      this.$blockUI.Start();
      this.$http
        .GetAllMunicipalities()
        .then((response) => {
          this.$blockUI.Stop();
          this.Municipalities = response.data.info;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    AddDevice(formName) {
      this.$blockUI.Start();
      this.ruleForm2.Count = Number(this.ruleForm2.Count)
      this.$http
        .AddDeviceToKindycenter(this.ruleForm2)
        .then(() => {
          this.$blockUI.Stop();
          Swal.fire({
            icon: "success",
            title: "تم الحفظ بنجاح",
            showCancelButton: false,
          }).then(() => {});
          this.GetKidneyCenters();
          document.getElementById("close2").click();
          this.resetForm2(formName);
          this.ruleForm2.KidneyCentersId = null;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    GetKidneyCenters(pageNo) {
      this.pageNo = pageNo;
      if (this.pageNo === undefined) {
        this.pageNo = 1;
      }
      this.$blockUI.Start();
      this.$http
        .KidneyCenters(this.pageNo, this.pageSize)
        .then((response) => {
          this.$blockUI.Stop();
          this.KidneyCenters = response.data.info;
          this.pages = response.data.count;
        })
        .catch(() => {
          this.$blockUI.Stop();
        });
    },
    deleteItem(id) {
      Swal.fire({
        title: "هـل انت متأكد من عملية الحذف ؟",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `تأكيد العملية`,
        denyButtonText: `الغاء العملية`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$blockUI.Start();
          this.$http
            .deleteKidneyCenters(id)
            .then((response) => {
              this.$blockUI.Stop();
              this.FormPorgress = 100;
              Swal.fire({
                icon: "success",
                title: "..نجـاح العملية",
                html: response.data,
                showCancelButton: false,
                //confirmButtonText: `حـفظ`,
              }).then(() => {
                this.$blockUI.Stop();
                this.GetKidneyCenters();
              });
            })
            .catch((err) => {
              this.$blockUI.Stop();
              this.$helper.showWorning(err.response.data);
            });
          return;
        }
      });
    },

    // CheckLoginStatus() {
    //     try {
    //         this.loginDetails = JSON.parse(localStorage.getItem('currentUser-client'));
    //         if (this.loginDetails == null) {
    //             window.location.href = '/Login';
    //         }
    //     } catch (error) {
    //         window.location.href = '/Login';
    //     }
    // },
  },
};
